import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EditTaskPanel from '../components/taskForms/EditTaskPanel';
import { useDispatch, useSelector } from '../context/Redux';
import { getTaskById as getTaskByIdAction } from '../redux/actions/tasksCRUD';
import { getTaskByIdSelector } from '../redux/selectors/tasks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EditTaskPanelContainer() {
  const {
    taskId
  } = useParams();
  const getTask = useSelector(getTaskByIdSelector);
  const task = getTask(taskId);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Preload the task-form chunk so it's ready when we render `EditTaskPanel`
    import( /* webpackChunkName: "task-form" */'../components/taskForms/BaseTaskForm');
  }, []);
  useEffect(() => {
    if (taskId) {
      setIsLoading(true);
      const onRequestFinished = () => setIsLoading(false);
      dispatch(getTaskByIdAction({
        taskId,
        onDone: onRequestFinished
      })).catch(e => console.error(e));
    }
  }, [dispatch, taskId]);
  if (!taskId || !task) {
    return null;
  }
  return /*#__PURE__*/_jsx(EditTaskPanel, {
    task: task,
    isLoading: isLoading
  });
}